unit UHolidayCancelForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, UMainConfig, Vcl.Imaging.pngimage, WEBLib.Buttons,
  UHolidayModel;

type
  THolidayCancelForm = class(TForm)
    pnlHeader: TPanel;
    lblHeader: TLabel;
    pnlButton: TPanel;
    btnOk: TBitBtn;
    btnCancel: TBitBtn;
    pnlDetails: TPanel;
    lblHeadline: TLabel;
    lblDurance: TLabel;
    gbReason: TGroupBox;
    memReason: TMemo;
    procedure WebFormResize(Sender: TObject);
    procedure memReasonChange(Sender: TObject);
    procedure btnOkClick(Sender: TObject);
    procedure btnCancelClick(Sender: TObject);
  private
    { Private-Deklarationen }
    FMainConfig: TMainConfig;
    FHoliday: THolidayModel;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetHoliday(const Value: THolidayModel);
  public
    { Public-Deklarationen }
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property Holiday: THolidayModel read FHoliday write SetHoliday;
  protected procedure LoadDFMValues; override; end;

var
  HolidayCancelForm: THolidayCancelForm;

implementation

uses
  UEssentialHelper;

{$R *.dfm}

procedure THolidayCancelForm.btnCancelClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
end;

procedure THolidayCancelForm.btnOkClick(Sender: TObject);
var helper: string;
begin
  Self.MainConfig.TimerReset;
  helper:=memReason.Text;
  helper:=StringReplace(helper,#10,' ',[rfReplaceAll]);
  Self.Holiday.Begruendung:=helper;
end;

procedure THolidayCancelForm.memReasonChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  if Length(memReason.Text)>255 then begin
    memReason.Text:=Copy(memReason.Text,1,255);
    MessageDLG('Die Begründung darf nicht mehr als 255 Zeichen haben!',mtWarning,[mbOK]);
  end;
end;

procedure THolidayCancelForm.SetHoliday(const Value: THolidayModel);
begin
  FHoliday := Value;
  lblHeadline.Caption:='Antrag auf '+Self.Holiday.Abw.Bezeichnung;
  lblDurance.Caption:=FormatDateTime('ddd. dd.mm.yyyy',Self.Holiday.Von)+' - '+FormatDateTime('ddd. dd.mm.yyyy',Self.Holiday.Bis);
  memReason.Text:=Self.Holiday.Begruendung;
end;

procedure THolidayCancelForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm:=Self.Name;
  ColorComponents(Self,Self.MainConfig.ColorConfig);
end;

procedure THolidayCancelForm.WebFormResize(Sender: TObject);
begin
  lblHeader.Left:=(pnlHeader.ClientWidth-lblHeader.Width) div 2;
end;

procedure THolidayCancelForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  lblHeader := TLabel.Create(Self);
  pnlButton := TPanel.Create(Self);
  btnOk := TBitBtn.Create(Self);
  btnCancel := TBitBtn.Create(Self);
  pnlDetails := TPanel.Create(Self);
  lblHeadline := TLabel.Create(Self);
  lblDurance := TLabel.Create(Self);
  gbReason := TGroupBox.Create(Self);
  memReason := TMemo.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  pnlButton.BeforeLoadDFMValues;
  btnOk.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  pnlDetails.BeforeLoadDFMValues;
  lblHeadline.BeforeLoadDFMValues;
  lblDurance.BeforeLoadDFMValues;
  gbReason.BeforeLoadDFMValues;
  memReason.BeforeLoadDFMValues;
  try
    Name := 'HolidayCancelForm';
    Width := 346;
    Height := 254;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 346;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 174;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.Caption := 'Antrag stornieren';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    pnlButton.SetParentComponent(Self);
    pnlButton.Name := 'pnlButton';
    pnlButton.Left := 0;
    pnlButton.Top := 190;
    pnlButton.Width := 346;
    pnlButton.Height := 64;
    pnlButton.Align := alBottom;
    pnlButton.Caption := 'pnlButton';
    pnlButton.ChildOrder := 3;
    pnlButton.ShowCaption := False;
    btnOk.SetParentComponent(pnlButton);
    btnOk.Name := 'btnOk';
    btnOk.Left := 8;
    btnOk.Top := 8;
    btnOk.Width := 160;
    btnOk.Height := 48;
    btnOk.Caption := 'Stornieren';
    btnOk.Color := clNone;
    btnOk.Glyph.LoadFromFile('UHolidayCancelForm.pnlButton.btnOk.Glyph.png');
    btnOk.GlyphSize := 32;
    btnOk.HeightPercent := 100.000000000000000000;
    btnOk.ModalResult := 1;
    btnOk.WidthPercent := 100.000000000000000000;
    SetEvent(btnOk, Self, 'OnClick', 'btnOkClick');
    btnCancel.SetParentComponent(pnlButton);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 176;
    btnCancel.Top := 8;
    btnCancel.Width := 160;
    btnCancel.Height := 48;
    btnCancel.Caption := 'Abbruch';
    btnCancel.Color := clNone;
    btnCancel.Glyph.LoadFromFile('UHolidayCancelForm.pnlButton.btnCancel.Glyph.png');
    btnCancel.GlyphSize := 32;
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.ModalResult := 2;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    pnlDetails.SetParentComponent(Self);
    pnlDetails.Name := 'pnlDetails';
    pnlDetails.Left := 0;
    pnlDetails.Top := 64;
    pnlDetails.Width := 346;
    pnlDetails.Height := 57;
    pnlDetails.Align := alTop;
    pnlDetails.Caption := 'pnlDetails';
    pnlDetails.ChildOrder := 1;
    pnlDetails.ShowCaption := False;
    lblHeadline.SetParentComponent(pnlDetails);
    lblHeadline.Name := 'lblHeadline';
    lblHeadline.Left := 8;
    lblHeadline.Top := 8;
    lblHeadline.Width := 60;
    lblHeadline.Height := 15;
    lblHeadline.Caption := 'lblHeadline';
    lblHeadline.Font.Charset := ANSI_CHARSET;
    lblHeadline.Font.Color := clNavy;
    lblHeadline.Font.Height := -12;
    lblHeadline.Font.Name := 'Segoe UI Semibold';
    lblHeadline.Font.Style := [fsBold];
    lblHeadline.HeightPercent := 100.000000000000000000;
    lblHeadline.ParentFont := False;
    lblHeadline.WidthPercent := 100.000000000000000000;
    lblDurance.SetParentComponent(pnlDetails);
    lblDurance.Name := 'lblDurance';
    lblDurance.Left := 8;
    lblDurance.Top := 32;
    lblDurance.Width := 57;
    lblDurance.Height := 15;
    lblDurance.Caption := 'lblDurance';
    lblDurance.HeightPercent := 100.000000000000000000;
    lblDurance.WidthPercent := 100.000000000000000000;
    gbReason.SetParentComponent(Self);
    gbReason.Name := 'gbReason';
    gbReason.Left := 0;
    gbReason.Top := 121;
    gbReason.Width := 346;
    gbReason.Height := 69;
    gbReason.Align := alClient;
    gbReason.BorderColor := clSilver;
    gbReason.Caption := 'Begr'#252'ndung';
    gbReason.ChildOrder := 3;
    memReason.SetParentComponent(gbReason);
    memReason.Name := 'memReason';
    memReason.Left := 0;
    memReason.Top := 0;
    memReason.Width := 346;
    memReason.Height := 69;
    memReason.Align := alClient;
    memReason.AutoSize := False;
    memReason.HeightPercent := 100.000000000000000000;
    memReason.Lines.BeginUpdate;
    try
      memReason.Lines.Clear;
      memReason.Lines.Add('memReason');
    finally
      memReason.Lines.EndUpdate;
    end;
    memReason.SelLength := 0;
    memReason.SelStart := 0;
    memReason.WidthPercent := 100.000000000000000000;
    SetEvent(memReason, Self, 'OnChange', 'memReasonChange');
  finally
    pnlHeader.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    pnlButton.AfterLoadDFMValues;
    btnOk.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    pnlDetails.AfterLoadDFMValues;
    lblHeadline.AfterLoadDFMValues;
    lblDurance.AfterLoadDFMValues;
    gbReason.AfterLoadDFMValues;
    memReason.AfterLoadDFMValues;
  end;
end;

end.
